import { ICommonServiceProps } from "@api/types/globalService.types";
import { useState } from "react";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useQuery } from "@tanstack/react-query";
import { getAllPincodesAPI } from "./pincode.api";


export const useAllPincodeServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: ICommonServiceProps) => {
  const [searchPincodeQuery, setSearchPincodeQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchPincodeQuery);
  const allPincodesService = useQuery({
    queryKey: [...CACHE_KEYS.PINCODES, page, debouncedQuery, per_page],
    queryFn: () =>
      getAllPincodesAPI({
        searchParams: {
          "filter[pincode]": debouncedQuery,
          page,
          per_page,
          include: "city,city.state",
        },
      }),

    enabled: enableQuery,
  });
  return {
    services: { allPincodesService },
    states: { setSearchPincodeQuery, searchPincodeQuery },
  };
};
